import { cn } from "@/lib/utils/cn";

/**
 * Issue icons are stored as Font Awesome class strings (e.g. "fal fa-recycle")
 * and drawn with Font Awesome, as the Django app draws them. The SPA ships the
 * free package, so brand icons keep `fab` and every other icon is drawn in the
 * free solid style. A name the free package does not know shows the tag glyph
 * (see `.issue-icon-glyph` in globals.css).
 */
export function issueIconClasses(icon?: string | null): string {
  const tokens = (icon ?? "").trim().split(/\s+/);
  const name = tokens.find(
    (token) => /^fa-[a-z0-9-]+$/i.test(token) && !STYLE_TOKENS.has(token),
  );
  const style = tokens.includes("fab") ? "fab" : "fas";
  return cn(style, name);
}

const STYLE_TOKENS = new Set([
  "fa-fw",
  "fa-lg",
  "fa-xs",
  "fa-sm",
  "fa-2x",
  "fa-3x",
  "fa-spin",
]);
